import Pusher from 'pusher-js';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ExtUpdateConnections, ExtUpdateJobs, ExtUploadStatus } from '../../actions/customExternal';

const ThePusherCustomExternal = () => {
    const dispatch = useDispatch();
    const activeAccount = useSelector((state) => state.subscriber.activeAccount);

    const handlePusher = () => {
        if (activeAccount.id) {
            // process.env.REACT_APP_PUSHER_KEY
            const pusher = new Pusher(process.env.REACT_APP_PUSHER_KEY, {
                cluster: process.env.REACT_APP_PUSHER_CLUSTER,
            });
            const channel = pusher.subscribe(`channel-${activeAccount.id}`);

            channel.bind('ExtUpdateConnections', function (data) {
                dispatch(ExtUpdateConnections(data));
            });

            channel.bind('ExtUpdateJobs', function (data) {
                dispatch(ExtUpdateJobs(data));
            });

            channel.bind('ExtUploadStatus', function (data) {
                dispatch(ExtUploadStatus(data));
            });

            return () => {
                channel.unbind();
            };
        }
    };
    useEffect(handlePusher, [activeAccount.id]); // eslint-disable-line
    return <></>;
};

export default React.memo(ThePusherCustomExternal);
